"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCheckpointSchedule = exports.getAuthorization = exports.prepareCreateCheckpointSchedule = exports.createCheckpointScheduleResolver = void 0;
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
const internal_2 = require("../../utils/internal");
/**
 * @hidden
 */
const createCheckpointScheduleResolver = (assetId, context) => (receipt) => {
    const [{ data }] = (0, internal_2.filterEventRecords)(receipt, 'checkpoint', 'ScheduleCreated');
    const rawId = data[2];
    const id = (0, conversion_1.u64ToBigNumber)(rawId);
    const rawPoints = data[3];
    const points = [...rawPoints.pending].map(rawPoint => (0, conversion_1.momentToDate)(rawPoint));
    return new internal_1.CheckpointSchedule({
        id,
        assetId,
        pendingPoints: points,
    }, context);
};
exports.createCheckpointScheduleResolver = createCheckpointScheduleResolver;
/**
 * @hidden
 */
function prepareCreateCheckpointSchedule(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context } = this;
        const { asset, points } = args;
        const now = new Date();
        const anyInPast = points.some(point => point < now);
        if (anyInPast) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.ValidationError,
                message: 'Schedule points must be in the future',
            });
        }
        const rawAssetId = (0, conversion_1.assetToMeshAssetId)(asset, context);
        const checkpointSchedule = (0, conversion_1.datesToScheduleCheckpoints)(points, context);
        return {
            transaction: context.polymeshApi.tx.checkpoint.createSchedule,
            args: [rawAssetId, checkpointSchedule],
            resolver: (0, exports.createCheckpointScheduleResolver)(asset.id, context),
        };
    });
}
exports.prepareCreateCheckpointSchedule = prepareCreateCheckpointSchedule;
/**
 * @hidden
 */
function getAuthorization({ asset }) {
    return {
        permissions: {
            transactions: [types_1.TxTags.checkpoint.CreateSchedule],
            assets: [asset],
            portfolios: [],
        },
    };
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
const createCheckpointSchedule = () => new internal_1.Procedure(prepareCreateCheckpointSchedule, getAuthorization);
exports.createCheckpointSchedule = createCheckpointSchedule;
//# sourceMappingURL=createCheckpointSchedule.js.map